import React, { useState, useContext } from "react";
import { Redirect } from "react-router";
import styled from "styled-components";

import { Row, Box, Img, Text } from "../../../comps";
import GuestPage from "./guest";
import { UIStateContext } from "../../../provider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Theme } from "../../../theme/theme-provider";
import { Z_INDEX } from "../../../constants";

import {
  faArrowAltCircleLeft,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { authBackground } from "../../../theme/uploaded";

const SCREEN_TYPE = {
  SUPPORTED: 0,
  NOT_SUPPORTED: 1,
};

const NotSupported = styled(Row)`
  position: fixed;
  width: 100vw;
  height: 100vh;
  align-items: center;
  background: ${({ theme }) => theme.color.BLACK_1};
  z-index: ${Z_INDEX.modal};
  justify-content: center;
`;

const Wrapper = styled(Box)`
  position: relative;
  width: 100%;
  height: 100vh;
  margin: 0px;
  padding: 80px;
  z-index: ${Z_INDEX.momo};
`;

const BackgroundImage = styled(Img)`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

const GoBack = styled(Row)`
  position: absolute;
  top: 5%;
  left: 5%;
  cursor: pointer;
  align-items: center;
`;

const Me = styled(Box)`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 30%;
  height: 8%;
  cursor: pointer;
  align-items: center;
  opacity: 0;
`;

const Content = styled(Row)`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  margin: 0px;
  padding: 80px;
  justify-content: space-between;
  align-items: center;
`;

const ArtWrapper = styled(Row)`
  width: 45%;
  height: 80%;
  align-items: center;
`;

const MODE = {
  LOGIN: 0,
  SIGNUP: 1,
  GOOGLE_STEP_2: 2,
  HOME: 3,
};

export default () => {
  const [UIState, setUIState] = useContext(UIStateContext);
  const { screen } = UIState;
  const [redirectTo, setRedirect] = useState("");
  const [mode, setMode] = useState(MODE.LOGIN);
  const [details, _setDetails] = useState({});

  const setDetails = (d) => {
    _setDetails(d);
    setMode(MODE.GOOGLE_STEP_2);
  };

  return screen === SCREEN_TYPE.NOT_SUPPORTED ? (
    <NotSupported>
      <Row alignItems="center">
        <FontAwesomeIcon
          style={{
            fontSize: "20px",
            color: Theme.color.GRAY_1,
            margin: "5px",
          }}
          icon={faInfoCircle}
        />
        <Text
          color={Theme.color.GRAY_0}
          fontSize="18px"
          textAlign="left"
          marginLeft="8px"
        >
          {`Screen size not supported!`}
        </Text>
      </Row>
    </NotSupported>
  ) : (
    <Wrapper>
      <BackgroundImage src={authBackground} />
      <Content>
        <ArtWrapper></ArtWrapper>
        <GuestPage
          mode={mode}
          setMode={setMode}
          details={details}
          setDetails={setDetails}
        />
      </Content>
      <GoBack
        onClick={() => {
          setRedirect("/intro");
        }}
      >
        <FontAwesomeIcon
          style={{ fontSize: "24px", color: Theme.color.GRAY_0 }}
          icon={faArrowAltCircleLeft}
        />
        <Text
          marginLeft="6px"
          fontSize="22px"
          color="#d7e0da"
          fontFamily={Theme.fontFamily.recursive}
          fontWeight={600}
        >{`Go Back to App`}</Text>
      </GoBack>
      <Me>
        <a
          style={{ width: "100%", height: "100%", display: "inline-block" }}
          href="https://avcbcoder.github.io/"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://avcbcoder.github.io/
        </a>
      </Me>
      {redirectTo && <Redirect push to={redirectTo} />}
    </Wrapper>
  );
};
